/**
 * register global dayjs
 */
import dayjs, { Dayjs, UnitTypeLong, UnitTypeLongPlural } from 'dayjs';

import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';
import 'dayjs/locale/id';
import 'dayjs/locale/th';
import 'dayjs/locale/tl-ph';
import 'dayjs/locale/es';
import 'dayjs/locale/vi';
import 'dayjs/locale/pt';

import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import localData from 'dayjs/plugin/localeData';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(localData);
dayjs.extend(quarterOfYear);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(timezone);

export default dayjs;

export type { Dayjs, UnitTypeLong, UnitTypeLongPlural };
